'use strict';

var BaseStaticView = require('actions/shared/AbstractStaticView');
var tpl = require('actions/wanProtocol/static.html');
var twig = require('twig').twig;

/**
 * Renders a text-only version of the "WAN Protocol" component.
 */
module.exports = BaseStaticView.extend({
  /**
   * @name actions/wanProtocol/StaticView#model
   * @type {actions/wanProtocol/EditWanProtocol}
   */

  template: twig({data: tpl}),
});
